/* eslint-disable @typescript-eslint/no-empty-function */
import React from 'react'
import './index.less'
import { Form, Input, Modal, Select } from '@arco-design/web-react'
import useNavProject from '@/useStore/createspace/useProject'
const FormItem = Form.Item
interface ICreateCopyModalProps {
    visible?: boolean
    title?: string
    onCancel?: () => void
    onSubmit?: (values?: any) => void
}
const CreateCopyModal: React.FC<ICreateCopyModalProps> = ({ visible, title = '', onCancel, onSubmit }) => {
    const [form] = Form.useForm()
    const { projectList, projectId } = useNavProject();
    const handleCancel = () => {
        form.resetFields()
        if (onCancel) onCancel()

    }
    return (
        <Modal
            title={title}
            visible={visible}
            onOk={() => {
                form.submit()
            }}
            onCancel={() => {
                handleCancel()
            }}
            autoFocus={false}
            focusLock={true}
            unmountOnExit={true}
            className={`vl-modal copy-modal-root`}>
            <Form
                autoComplete="off"
                layout={"vertical"}
                form={form}
                initialValues={{
                }}
                onSubmit={() => {
                    if (onSubmit) onSubmit(form.getFieldsValue())
                    handleCancel()

                }}
            >

                <FormItem
                    label="文案名称"
                    field="name"
                    rules={[{ required: true, message: "文案名称是必填项" }]}>
                    <Input placeholder="请填写文案名称" />
                </FormItem>
                <FormItem
                    rules={[{ required: true, message: "请选择项目" }]}
                    label="保存位置"
                    field={"project_id"}
                    tooltip={<div>请选择保存文案位置</div>}>
                    <Select
                        placeholder='请选择'
                        options={projectList.map((item) => {
                            return {
                                value: item.id,
                                label: item.name,
                            };
                        })}></Select>
                </FormItem>
            </Form>
        </Modal>
    )
}

export default CreateCopyModal